module.exports = __webpack_public_path__ + "static/media/toelogic-1.ac62e6eb.jpg";